export default __webpack_public_path__ + "static/media/legal_policy_compliance.ba329ca2.png";